<template>
  <content-container>
    <div class="show-margin">
      <section>
        <h1>Страницы кабинета</h1>
        <div v-for="n in 31" :key="n">
          <div>{{ $tc("license.y", n) }}, {{ $tc("license.m", n) }}, {{ $tc("license.d", n) }}</div>
          <div><a href="/test.license" download="test.license">Скачать файд лицензии</a></div>
        </div>
      </section>
    </div>
  </content-container>
</template>

<script>
import ContentContainer from '../ContentContainer.vue';
// @ is an alias to /src

export default {
  components: { ContentContainer },
  name: "Components",
};
</script>

<style scoped>

</style>